import { dayjs } from './dayjs.utils';

// eslint-disable-next-line import/prefer-default-export
export const isAbsenceActive = absence => {
  if (!absence) return false;

  return dayjs().isBetween(dayjs(absence.startAt), dayjs(absence.endAt));
};
